import { useLang } from 'hooks/lang';

import { AddCountryRequestStatus } from 'entities';

import { Modal } from 'components/Blocks';

import { AddCountryRequestSuccess } from './Success';
import { RequestCountryForm } from './RequestForm';
import { ApproveCountryForm } from './ApproveForm';

import { useProjectProfile } from '../../context';

interface AddCountryProps {
  children?: never;
  isOpen: boolean;
  close: () => void;
}

const flowToComponents: {
  [key in Exclude<AddCountryRequestStatus, undefined>]: typeof AddCountryRequestSuccess;
} = {
  REQUESTED: AddCountryRequestSuccess,

  APPROVED: RequestCountryForm,

  WAITING_APPROVAL: ApproveCountryForm,

  REJECTED: RequestCountryForm,
};

export function AddCountryModal({ isOpen, close }: AddCountryProps) {
  const { project } = useProjectProfile();

  const { t } = useLang();

  const { addCountryRequest } = project;

  const FlowComponent = flowToComponents[addCountryRequest?.status || 'APPROVED'];

  return (
    <Modal
      close={close}
      isOpen={isOpen}
      width="min(90vw, 850px)"
      title={t('add-new-country')}
      className="overflow-y-auto"
    >
      <FlowComponent />
    </Modal>
  );
}
